/* eslint-disable */
import ReactDOM from "react-dom";
import { get } from 'lodash';
import moment from 'moment';
import { buildResponses } from '@unite-us/ui-surveyjs2';
import {
  ELEMENT_DICTIONARY_V3,
  OPTION_DICTIONARY_V3,
} from "src/pages/facesheet/_id/eligibility/surveyjsTemplates/createElAssessTemplate"
import getEligibleServiceUtilV4 from "./getEligibilityV4";
import getEligibleServiceUtilV5 from "./getEligibilityV5";
import {
  transportationNeedHTML,
  foodNeedHTML,
  housingNeedHTML,
  interpersonalSafetyNeedHTML,
  utilitiesNeedHTML,
  unemploymentNeedHTML,
  educationNeedHTML,
  transportationNeedHTMLdeprecated,
  foodNeedHTMLdeprecated,
  housingNeedHTMLdeprecated,
  interpersonalSafetyNeedHTMLdeprecated,
  utilitiesNeedHTMLdeprecated,
  unemploymentNeedHTMLdeprecated,
  educationNeedHTMLdeprecated,
  getNoNeedsHTML,
} from "src/pages/facesheet/_id/eligibility/identifiedNeedsHtml";

export const ELIGIBILITY_ASSESSMENT_STATUS = {
  DRAFT: 'draft',
  COMPLETE: 'complete',
  DECLINED: 'declined',
};

export const getLastUpdatedDate = (screen) => {
  const status = get(screen, 'status', '');
  const lastUpdated = screen.updated_at ? moment(screen.updated_at).format('LL') : '';
  const statusAt = screen.status_at ? moment(screen.status_at).format('LL') : '';
  const isDraft = status === ELIGIBILITY_ASSESSMENT_STATUS.DRAFT;
  const savedDate = isDraft ? lastUpdated : statusAt;
  return savedDate;
};

export const ELIGIBLE_SERVICES_LIST = [
  {
    name: 'Home Accessibility / Safety Modification',
    need: 'Housing',
  },
  {
    name: 'Home Remediation Assistance: Mold and Pest',
    need: 'Housing',
  },
  {
    name: 'Home Remediation Assistance: Ventilation Improving Systems',
    need: 'Housing',
  },
  {
    name: 'Home Remediation Assistance: Equipment provision',
    need: 'Housing',
  },
  {
    name: 'Asthma Remediation',
    need: 'Housing',
  },
  {
    name: 'Medical Respite - Preprocedural Care',
    need: 'Housing',
  },
  {
    name: 'Medical Respite - Post Hospitalization Care',
    need: 'Housing',
  },
  {
    name: 'Rent/Temporary Housing Rent Payment Assistance',
    need: 'Housing',
  },
  {
    name: 'Utility Payment Assistance',
    need: 'Utilities',
  },
  {
    name: 'Utility Activation Payment',
    need: 'Utilities',
  },
  {
    name: 'Utility Arrears Payment',
    need: 'Utilities',
  },
  {
    name: 'Pre-tenancy Services',
    need: 'Housing',
  },
  {
    name: 'Community Transitional Supports',
    need: 'Housing',
  },
  {
    name: 'Tenancy Sustaining services',
    need: 'Housing',
  },
  {
    name: 'Housing Transition and Navigation Services',
    need: 'Housing',
  },
  {
    name: 'Nutritional Counseling and Education',
    need: 'Food',
  },
  {
    name: 'Medically Tailored Meals (MTM)',
    need: 'Food',
  },
  {
    name: 'Clinically Appropriate Meals',
    need: 'Food',
  },
  {
    name: 'Food Prescriptions (Voucher / Boxes)',
    need: 'Food',
  },
  {
    name: 'Fresh Produce and Nonperishable Groceries - Pantry Stocking',
    need: 'Food',
  },
  {
    name: 'Cooking Supplies',
    need: 'Food',
  },
  {
    name: 'Private Transportation (must also have at least one other HRSN need)',
    need: 'Transportation',
  },
  {
    name: 'Public Transportation (must also have at least one other HRSN need)',
    need: 'Transportation',
  },
];

// To be confirmed if it should be used in V4:
export const getServiceNeed = (service) => {
  const serviceObj = ELIGIBLE_SERVICES_LIST.find((s) => s.name === service);
  return ` (${serviceObj?.need})` || '';
};

export const getEligibilityAssessmentStatusLabel = (status, outreach_status) => {
  if (outreach_status?.toLowerCase() === 'declined') {
    return 'Outreach Failed';
  }
  return status;
};

export const buildAnswersPayload = (surveyRef, surveyJSON) => {
  const survey = surveyRef.current;

  const responses = buildResponses(surveyRef.current);
  const answers = responses
    .filter((response) => {
      if (['qSelectScreening'].includes(response.name)) {
        return false;
      }
      return true;
    })
    .map((response) => {
      let option_id = null;
      const optionsSelected = response.custom.map((c) => c.option.uuid || c.option.id);
      const questionType = get(response, 'custom[0].question.type', '');
      option_id = optionsSelected;
      
      if (response.value) {
        option_id = response.value;
      } else if (questionType === 'select_multiple') {
        option_id = Array.isArray(optionsSelected) ? optionsSelected : [optionsSelected];
      } else if (optionsSelected.length > 1) {
        option_id = optionsSelected;
      } else {
        option_id = optionsSelected[0];
      }
      return {
        question_id: response.custom[0].questionId,
        option_id,
      }
    });

  return answers;
};

export const SELECT_SCREENING_QUESTION = 'Select screening to validate HRSN social needs';

export const ESMF_TYPES = {
  enhancedPopulation: 'enhanced_population',
  clinicalCondition: 'clinical_condition',
  serviceDuplication: 'service_duplication',
};

export const DECLINED_REASON = "Client declined consent to participate in the Eligibility Assessment";

export const NotEligibleHtml = `
<div>
  <button style="background-color: rgba(68, 103, 171, var(--bg-opacity)); color: white; border-radius: 2px; padding-left: 5px; padding-right: 5px; padding-top: 2px; padding-bottom: 2px; font-weight: bold; font-size: 20px;" className="font-bold bg-white text-lg">You are not eligible. Back!</button>
</div>
`;

const findElementByPrimaryText = (screen, primaryText) => screen.questions.find(
  (q) => q.primary_text === primaryText
)

const getAnswer = (question) => get(question, 'answer.value');
const getAnswerValues = (question) => get(question, 'answers', []).map((a) => a.value);
const isAnswerYes = (question) => Boolean(get(question, 'answer.value') === 'Yes');
const getSnomedCodesSelected = (screen) => {
  const idToCode = Object.fromEntries(
    screen.questions.flatMap(q =>
      (q.options ?? [])
        .filter(o => o.snomed)
        .map(o => [o.id, o.snomed])
    )
  );

  return screen.questions.flatMap(q => {
    const selected = [
      ...(q.answer  ? [q.answer]  : []),
      ...(q.answers ? q.answers  : [])
    ];
    return selected
      .map(a => idToCode[a.option_id])
      .filter(Boolean);
  });
};


// Clinically Appropriate Meals
const getServicesForMeals = ({ hasFoodNeed, enhancedPopulations }) => {
  const eligibleServices = [];
  if (
    hasFoodNeed &&
    enhancedPopulations.length > 0
  ) {
    eligibleServices.push('Clinically Appropriate Meals');
    eligibleServices.push('Medically Tailored Meals (MTM)');
  }
  return eligibleServices;
};

// Cooking Supplies
const getServicesForCookingSupplies = ({ hasFoodNeed, enhancedPopulations }) => {
  if (!hasFoodNeed) { return []; }

  const eligibleServices = [];
  if (
    enhancedPopulations.length > 0
  ) {
    eligibleServices.push('Cooking Supplies');
    eligibleServices.push('Nutritional Counseling and Education');
  }
  return eligibleServices;
};

// Fresh Produce
const getServicesForFreshProduce = ({ hasFoodNeed, enhancedPopulations }) => {
  if (!hasFoodNeed) { return []; }
  const eligibleServices = [];
  const requirements = (
    enhancedPopulations.includes(OPTION_DICTIONARY_V3.pregnantAndPostpartumV3) ||
    enhancedPopulations.includes(OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3) ||
    enhancedPopulations.includes(OPTION_DICTIONARY_V3.childNutritionV3)
  );
  if (requirements) {
    eligibleServices.push('Fresh Produce and Nonperishable Groceries - Pantry Stocking');
  }
  return eligibleServices;
};

// Asthma Remediation
const getServicesForAsthmaRemediation = ({
  hasHousingOrUtilitiesNeed,
  clinicalCriteria,
  enhancedPopulations,
}) => {
  if (!hasHousingOrUtilitiesNeed) { return []; }
  const eligibleServices = [];
  if (
    clinicalCriteria.includes(OPTION_DICTIONARY_V3.asthma) &&
    enhancedPopulations.length
  ) {
    eligibleServices.push('Asthma Remediation');
  }
  return eligibleServices;
};

// Community Transitional Support
const getServicesForCommunityTransitionalSupport = ({
  hasHousingOrUtilitiesNeed,
  snomedCodesSelected,
  enhancedPopulations,
}) => {
  if (!hasHousingOrUtilitiesNeed) { return []; }
  if (!enhancedPopulations.length) { return []; }
  const snomedRequirements = [
    snomedCodesSelected.includes('611551000124102') ||
    snomedCodesSelected.includes('611131000124100') ||
    snomedCodesSelected.includes('611141000124105') ||
    snomedCodesSelected.includes('611181000124104') ||
    snomedCodesSelected.includes('32911000'),
  ];
  const eligibleServices = [];
  if (snomedRequirements) {
    eligibleServices.push('Community Transitional Supports');
  }
  return eligibleServices;
};

// Home Accessibility
const getServicesForHomeAccessibility = ({
  hasHousingOrUtilitiesNeed,
  hasDifficultyWalking,
  hasDifficultyDressing,
  enhancedPopulations,
}) => {
  if (!hasHousingOrUtilitiesNeed) { return []; }
  if (!enhancedPopulations.length) { return []; }
  const eligibleServices = [];
  if (
      hasDifficultyWalking ||
      hasDifficultyDressing
  ) {
    eligibleServices.push('Home Accessibility / Safety Modification');
  }
  return eligibleServices;
};

// Home Remediation
const getServicesForHomeRemediation = ({
  isV2,
  isV3,
  hasHousingOrUtilitiesNeed,
  clinicalCriteria,
  enhancedPopulations,
}) => {
  if (!hasHousingOrUtilitiesNeed) return [];

  const CLINICAL_TRIGGERS = [
    OPTION_DICTIONARY_V3.chronicCondition,
    OPTION_DICTIONARY_V3.heatRelatedIllnessV3,
    OPTION_DICTIONARY_V3.coldRelatedIllnessV3,
  ];

  const POPS_V2 = [
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.idd,
    OPTION_DICTIONARY_V3.sud,
    OPTION_DICTIONARY_V3.mentalHealth,
  ];

  const POPS_V3 = [
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.otherPopulations,
    OPTION_DICTIONARY_V3.childNutritionV3,
  ];

  const hasAny = (list, targets) => targets.some((t) => list.includes(t));

  const clinicalHit  = hasAny(clinicalCriteria, CLINICAL_TRIGGERS);
  const popV2Hit     = hasAny(enhancedPopulations, POPS_V2);
  const popV3Hit     = hasAny(enhancedPopulations, POPS_V3);

  const eligible =
    (isV2 && (clinicalHit || popV2Hit)) ||
    (isV3 && (clinicalHit || popV3Hit));

  return eligible
    ? [
        'Home Remediation Assistance',
        'Home Remediation Assistance: Space Heater',
      ]
    : [];
};

// Refrigeration
const getServicesForRefrigeration = ({
  hasHousingOrUtilitiesNeed,
  enhancedPopulations,
  clinicalCriteria,
  requireRefrigerationBreastMilk,
  requireRefrigerationMedication,
}) => {
  if (!hasHousingOrUtilitiesNeed) { return []; }
  const eligibleServices = [];
  const requirements = (
    enhancedPopulations.length &&
    (
      requireRefrigerationBreastMilk ||
      requireRefrigerationMedication ||
      clinicalCriteria.includes(OPTION_DICTIONARY_V3.enternalOrParenteral)
    )
  );
  if (requirements) {
    eligibleServices.push('Home Remediation Assistance: Refrigerator');
  }
  return eligibleServices;
}

// Housing Transition
const getServicesForHousingTransition = ({
  isV2,
  isV3,
  hasHousingOrUtilitiesNeed,
  enhancedPopulations,
  snomedCodesSelected,
}) => {
  if (!hasHousingOrUtilitiesNeed) return [];
  const POPS_V2 = [
    OPTION_DICTIONARY_V3.medicaidHighUtilizer,
    OPTION_DICTIONARY_V3.enrolledNYSV3,
    OPTION_DICTIONARY_V3.sud,
    OPTION_DICTIONARY_V3.mentalHealth,
    OPTION_DICTIONARY_V3.idd,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.individualsChronicReleased,
    OPTION_DICTIONARY_V3.juvenileJustice,
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
  ];
  const POPS_V3 = [
    OPTION_DICTIONARY_V3.medicaidHighUtilizer,
    OPTION_DICTIONARY_V3.enrolledNYSV3,
    OPTION_DICTIONARY_V3.otherPopulations,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.individualsChronicReleased,
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
    OPTION_DICTIONARY_V3.childNutritionV3,
  ];
  const SNOMED_HOUSING = [
    '611551000124102',
    '611131000124100',
    '611141000124105',
    '611181000124104',
    '32911000',
  ];
  const hasAny = (list, targets) => targets.some((t) => list.includes(t));
  const popV2Hit  = hasAny(enhancedPopulations, POPS_V2);
  const popV3Hit  = hasAny(enhancedPopulations, POPS_V3);
  const snomedHit = hasAny(snomedCodesSelected, SNOMED_HOUSING);
  const eligible =
    (isV2 && popV2Hit && snomedHit) ||
    (isV3 && popV3Hit && snomedHit);
  return eligible
    ? [
        'Housing Transition and Navigation Services',
        'Pre-tenancy Services',
        'Tenancy Sustaining services',
      ]
    : [];
};

// Utility Payment
const getServicesForUtilityPayment = ({
  isV2,
  isV3,
  hasHousingOrUtilitiesNeed,
  enhancedPopulations,
  snomedCodesSelected,
}) => {
  if (!hasHousingOrUtilitiesNeed) return [];
  const POPS_V2 = [
    OPTION_DICTIONARY_V3.individualsChronicReleased,
    OPTION_DICTIONARY_V3.mentalHealth,
    OPTION_DICTIONARY_V3.idd,
    OPTION_DICTIONARY_V3.juvenileJustice,
  ];
  const SNOMED_UTILITY = [
    '611551000124102',
    '611131000124100',
    '611141000124105',
    '611181000124104',
    '32911000',
  ];
  const hasAny = (list, targets) => targets.some((t) => list.includes(t));
  const popV2Match       = hasAny(enhancedPopulations, POPS_V2);
  const snomedMatch      = hasAny(snomedCodesSelected, SNOMED_UTILITY);
  const anyEnhancedPops  = enhancedPopulations.length > 0;
  const eligible =
    (isV2 && (popV2Match || snomedMatch)) ||
    (isV3 && (anyEnhancedPops && snomedMatch));
  return eligible
    ? [
        'Utility Payment Assistance',
        'Rent/Temporary Housing Rent Payment Assistance',
        'Rent/Temporary Housing Rent Payment Assistance - Four Bedroom Unit (per month)',
        'Utility Activation Payment',
        'Utility Arrears Payment',
      ]
    : [];
};

// Transportation
const getServicesForTransportation = ({
  isV2,
  isV3,
  hasTransportationNeed,
  enhancedPopulations,
  snomedCodesSelected,
  transportationTroubleReasons,
}) => {
  if (!hasTransportationNeed) return [];
  const POPS_V2 = [
    OPTION_DICTIONARY_V3.medicaidHighUtilizer,
    OPTION_DICTIONARY_V3.enrolledNYSV3,
    OPTION_DICTIONARY_V3.sud,
    OPTION_DICTIONARY_V3.mentalHealth,
    OPTION_DICTIONARY_V3.idd,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.individualsChronicReleased,
    OPTION_DICTIONARY_V3.juvenileJustice,
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
  ];
  const POPS_V3 = [
    OPTION_DICTIONARY_V3.medicaidHighUtilizer,
    OPTION_DICTIONARY_V3.enrolledNYSV3,
    OPTION_DICTIONARY_V3.otherPopulations,
    OPTION_DICTIONARY_V3.pregnantAndPostpartumV3,
    OPTION_DICTIONARY_V3.individualsChronicReleased,
    OPTION_DICTIONARY_V3.highRiskChildUnderEighteenV3,
    OPTION_DICTIONARY_V3.childNutritionV3,
  ];
  const SNOMED_TRANSPORT = [
    '551761000124107',
    '551741000124108',
    '551721000124101',
    '611151000124107',
    '551701000124106',
    '551711000124109',
    '160696009',
  ];
  const TROUBLE_REASONS = [
    "I don't have a valid driver's license",
    "I don't have access to a vehicle",
  ];
  const hasAny = (list, targets) => targets.some((t) => list.includes(t));

  const matchesPopulation =
    (isV2 && hasAny(enhancedPopulations, POPS_V2)) ||
    (isV3 && hasAny(enhancedPopulations, POPS_V3));

  const hasTransportSignal =
    hasAny(snomedCodesSelected, SNOMED_TRANSPORT) ||
    hasAny(transportationTroubleReasons, TROUBLE_REASONS);

  return matchesPopulation && hasTransportSignal
    ? ['Private Transportation', 'Public Transportation']
    : [];
};

// identifiedNeeds is an array of strings (e.g. ['food', 'housing'])
// screening is the eligibility assessment screening object
export const getEligibleServicesUtil = (screening, identifiedNeeds, options = {}) => {
  try {
    if (!screening) { return null; }
    const { template_version } = screening.data.screen;
    const isV2 = template_version === '2';
    const isV3 = template_version === '3';
    const isV4 = template_version === '4';
    const isV5 = template_version === '5';
    // V6+ eligible services are calculated backend-side (V6EligibleServicesCalculator)
    // and returned as-is on the screen; nothing to compute here.
    if (Number(template_version) >= 6) {
      return get(screening, 'data.screen.eligible_services', []);
    }
    if (isV5) {
      return getEligibleServiceUtilV5(screening, identifiedNeeds, options);
    }
    if (isV4) {
      return getEligibleServiceUtilV4(screening, identifiedNeeds);
    }

    let eligibleServices = [];
    const screen = screening.data.screen;
    const qVerifyMedicaidEnrollment = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qVerifyMedicaidEnrollmentV3);
    const qVerifyIdentity = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qVerifyIdentity);
    const qConfirmAccurateInfo = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qConfirmAccurateInfo);
    const qNYExcludedPopulation = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qNYExcludedPopulation);
    const qFoodAssistance = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qFoodAssistance);
    const qHousingUtilitiesAssistance = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qHousingUtilitiesAssistance);
    const qTransportationAssistance = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qTransportationAssistance);
    const qEnhancedPopulations = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qEnhancedPopulations);
    const qClinicalCriteria = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qClinicalCriteria);
    const qDifficultyWalking = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qDifficultyWalking);
    const qDifficultyDressing = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qDifficultyDressing);
    const qRefrigerationBreastMilk = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qRefrigerationBreastMilk);
    const qRefrigerationMedication = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qRefrigerationMedication);
    const qTransportationTroubleReasons = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qTransportationTroubleReasons);
    const qSelectScreening = findElementByPrimaryText(screen, ELEMENT_DICTIONARY_V3.qSelectScreening);

    let hasAccurateInfo = getAnswer(qConfirmAccurateInfo) === OPTION_DICTIONARY_V3.oMemberDoesAttest;
    let hasVerifiedIdentity = getAnswer(qVerifyIdentity) === "I was able to verify member's identity.";
    // const VERIFIED_MEDICAID_ANSWERS = {
    //   // Option available before April 8
    //   GENERAL_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid.',
    //   // Options available after April 8
    //   MANAGED_CARE_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid Managed Care.',
    //   FFS_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid Fee-for-Service.',
    //   NOT_VERIFIED: 'I was not able to verify the member is currently enrolled in Medicaid.',
    // };

    const medicaidEnrollmentAnswer = getAnswer(qVerifyMedicaidEnrollment);
    const hasVerifiedMedicaid = medicaidEnrollmentAnswer === OPTION_DICTIONARY_V3.oVerifyMedicaidEnrollmentGeneralVerified ||
      medicaidEnrollmentAnswer === OPTION_DICTIONARY_V3.oVerifyMedicaidEnrollmentConfirmed
    let isMemberInExcludedPopulation = isAnswerYes(qNYExcludedPopulation);
    let hasValidScreening = Boolean(get(screening, 'data.screen.related_screen_id'));

    const wantsFoodAssistance = isAnswerYes(qFoodAssistance);
    const wantsHousingOrUtilitiesAssistance = isAnswerYes(qHousingUtilitiesAssistance);
    const wantsTransportationAssistance = isAnswerYes(qTransportationAssistance);
    const hasFoodNeed = Boolean(
      identifiedNeeds.includes('food') && wantsFoodAssistance
    );
    const hasHousingOrUtilitiesNeed = Boolean(
      (identifiedNeeds.includes('housing') || identifiedNeeds.includes('utilities')
    ) &&
      wantsHousingOrUtilitiesAssistance
    );
    const hasTransportationNeed = Boolean(
      identifiedNeeds.includes('transportation') && wantsTransportationAssistance
    );
    const enhancedPopulations = getAnswerValues(qEnhancedPopulations);
    const clinicalCriteria = getAnswerValues(qClinicalCriteria);
    
    const hasDifficultyWalking = isAnswerYes(qDifficultyWalking);
    const hasDifficultyDressing = isAnswerYes(qDifficultyDressing);
    const requireRefrigerationBreastMilk = isAnswerYes(qRefrigerationBreastMilk);
    const requireRefrigerationMedication = isAnswerYes(qRefrigerationMedication);
    const transportationTroubleReasons = getAnswerValues(qTransportationTroubleReasons);
    const snomedCodesSelected = getSnomedCodesSelected(screen);

    // Base eligibility requirements
    const baseRequirements = hasAccurateInfo
      && hasVerifiedIdentity
      && hasVerifiedMedicaid
      && hasValidScreening
      && !isMemberInExcludedPopulation;
    if (!baseRequirements) {
      return [];
    }

    eligibleServices = [
      ...eligibleServices,
      ...getServicesForMeals({ hasFoodNeed, enhancedPopulations }),
      ...getServicesForCookingSupplies({ hasFoodNeed, enhancedPopulations }),
      ...getServicesForFreshProduce({ hasFoodNeed, enhancedPopulations }),
      ...getServicesForAsthmaRemediation({
        hasHousingOrUtilitiesNeed,
        clinicalCriteria,
        enhancedPopulations,
      }),
      ...getServicesForCommunityTransitionalSupport({
        hasHousingOrUtilitiesNeed,
        snomedCodesSelected,
        enhancedPopulations,
      }),
      ...getServicesForHomeAccessibility({
        hasHousingOrUtilitiesNeed,
        hasDifficultyWalking,
        hasDifficultyDressing,
        enhancedPopulations,
      }),
      ...getServicesForHomeRemediation({
        isV2,
        isV3,
        hasHousingOrUtilitiesNeed,
        clinicalCriteria,
        enhancedPopulations,
      }),
      ...getServicesForRefrigeration({
        hasHousingOrUtilitiesNeed,
        enhancedPopulations,
        clinicalCriteria,
        requireRefrigerationBreastMilk,
        requireRefrigerationMedication,
      }),
      ...getServicesForHousingTransition({
        isV2,
        isV3,
        hasHousingOrUtilitiesNeed,
        enhancedPopulations,
        snomedCodesSelected,
      }),
      ...getServicesForUtilityPayment({
        isV2,
        isV3,
        hasHousingOrUtilitiesNeed,
        enhancedPopulations,
        snomedCodesSelected,
      }),
      ...getServicesForTransportation({
        isV2,
        isV3,
        hasTransportationNeed,
        enhancedPopulations,
        snomedCodesSelected,
        transportationTroubleReasons,
      }),
    ];

    return eligibleServices;
  } catch (error) {
    console.error('Error getting eligible services', error);
    return [];
  }
};

export const formatDateToScreeningFormat = (dateString) => {
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  const dateObj = new Date(dateString);
  const formattedDate = dateObj.toLocaleDateString('en-US', options);
  return formattedDate;
};

export const getIdentifiedNeedsHTML = (scrn942ScreeningsResultsUpdatesEnabled, needs = []) => {
  const containerClass =
    'border-solid border border-dark-pale-blue bg-lighter-grey px-6 py-6 mb-5';

  if (!needs.length) return getNoNeedsHTML(containerClass);

  const SNIPPETS = scrn942ScreeningsResultsUpdatesEnabled ? {
    transportation: transportationNeedHTML,
    food: foodNeedHTML,
    housing: housingNeedHTML,
    interpersonal_safety: interpersonalSafetyNeedHTML,
    utilities: utilitiesNeedHTML,
    unemployment: unemploymentNeedHTML,
    education: educationNeedHTML,
  } : {
    transportation: transportationNeedHTMLdeprecated,
    food: foodNeedHTMLdeprecated,
    housing: housingNeedHTMLdeprecated,
    interpersonal_safety: interpersonalSafetyNeedHTMLdeprecated,
    utilities: utilitiesNeedHTMLdeprecated,
    unemployment: unemploymentNeedHTMLdeprecated,
    education: educationNeedHTMLdeprecated,
  };

  const body = needs
    .filter((need) => SNIPPETS[need])
    .map((need) => SNIPPETS[need])
    .join('');

  return `
    <div class="${containerClass}">
      <p class="text-lg font-bold mb-5">
        Selected Screening Identified These Health-Related Social Needs:
      </p>
      ${body}
    </div>
  `;
};


export const snomedIdentifiedNeedMapping = {
  "551761000000000": "transportation",
  "551761000124107": "transportation",
  "551741000124108": "transportation", 
  "551721000124101": "transportation",
  "611151000124107": "transportation",
  "551701000000000": "transportation",
  "551701000124106": "transportation",
  "551711000124109": "transportation",
  "160696009": "transportation",
  "551691000124106": "transportation",
  "611161000124109": "transportation",
  "551731000124103": "transportation",
  "551751000124105": "transportation",

  "1156191002": "housing",
  "32911000": "housing",
  "1156195006": "housing",
  "1156193004": "housing", 
  "1187272007": "housing",
  "1156196007": "housing",
  "1156192009": "housing",
  "1156194005": "housing",
  "611551000124102": "housing",
  "611131000124100": "housing",
  "611551000124105": "housing",
  "611141000124105": "housing",
  "611551000124104": "housing",
  "611181000124104": "housing",
  "105535008": "housing",
  "1162585007": "housing",
  "105531004": "housing",
  "224255009": "housing",
  "1197631001": "housing",
  "1197634009": "housing",
  "1197640002": "housing",

  "105536009": "utilities",
  "1184702004": "utilities",
  "5491000175103": "utilities",
  "671391000124106": "utilities",
  "671371000124105": "utilities",
  "671401000124108": "utilities",

  "73438004": "unemployment",
  "75148009": "unemployment",

  "4506002": "education",

  "733423003": "food"
};
